import { render, staticRenderFns } from "./top-tip.vue?vue&type=template&id=4315e4f1&scoped=true&"
import script from "./top-tip.vue?vue&type=script&lang=js&"
export * from "./top-tip.vue?vue&type=script&lang=js&"
import style0 from "./top-tip.vue?vue&type=style&index=0&id=4315e4f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4315e4f1",
  null
  
)

export default component.exports